import { Route, Routes } from 'react-router';

import Tmmunity from 'src/r_page/Trainer-Community';
import TrainerCommunityFeed from 'src/r_page/Trainer-Community/Feed';
import TrainerCommunitySave from 'src/r_page/Trainer-Community/Save';
import TrainerCommunityWrite from 'src/r_page/Trainer-Community/Write';

const TrainerCommunityView = () => {
  return (
    <Routes>
      <Route path="" element={<Tmmunity />} />
      <Route path="/write" element={<TrainerCommunityWrite />} />
      <Route path="/save" element={<TrainerCommunitySave />} />
      <Route path="/:id" element={<TrainerCommunityFeed />} />
      <Route path="/:params/:id" element={<TrainerCommunityWrite />} />
    </Routes>
  );
};

export default TrainerCommunityView;
